import { RESET_TRUCK_CART, GET_TRUCK_CART } from '../actions/actionTypes';

import TruckCart from '../../models/TruckCart';

const initialState: TruckCart = { cart: [], pickup_date: '' };

export const truckCartReducer = (state = initialState, action: any) => {

  switch (action.type) {

    case RESET_TRUCK_CART:
      return initialState;
    case GET_TRUCK_CART:
      return {
        ...state,
        cart: [...action.data.cart],
        pickup_date: action.data.pickup_date
      }
    default:
      return state;
  }

};